export interface CreatePaymentProfileRequest {
    customerId: number;
    firstName: string;
    lastName: string;
    address: string;
    postalCode: string;
    city: string;
    state: string;
    country: string;
    creditCardNumber: string;
    creditCardExpirationMonth: number;
    creditCardExpirationYear: number;
    creditCardCvv: string;
}

export interface PaymentTokenData {
    paymentTokenId: string;
    firstName?: string;
    lastName?: string;
    address?: string;
    city?: string;
    state?: string;
    postalCode?: string;
    country?: string;
}

/**
 * Billing details for payment method creation
 * Used by payment card components to create payment methods
 */
export interface BillingDetails {
    customerId?: number;
    fullName: string;
    email?: string;
    phone?: string;
    address: string;
    city: string;
    state: string;
    postalCode: string;
    country?: string;
}


/**
 * Card data state for tracking card input
 * Emitted by payment card components
 */
export interface CardDataState {
    isEmpty: boolean;
    isComplete: boolean;
    isValid: boolean;
    error?: string;
    cardBrand?: string;
}

export interface PayPalTokenResponse {
    data: string;
}

export interface MerchantPlatformSettings {
    platform: PaymentProvider;
    credentials1?: string;
    credentials2?: string;
    credentials3?: string;
    credentials4?: string;
}

export enum PaymentProvider {
    None = 'None',
    AuthorizeNet = 'AuthorizeNet', // 1
    PayPal = 'PayPal', // 5
    Stripe = 'Stripe' // 7
}
